/**
 * Constants for the notification system
 * Centralized configuration for maintainability
 */

export const NOTIFICATION_CONSTANTS = {
  // Timing
  REFRESH_INTERVAL_MS: 5 * 60 * 1000, // 5 minutes
  
  // UI
  MAX_BADGE_COUNT: 9, // Show "9+" for counts over 9
  DROPDOWN_WIDTH_PX: 400,
  DROPDOWN_MAX_HEIGHT_PX: 500,
  
  // Storage
  DISMISSED_STORAGE_KEY: 'dismissedNotifications',
  MAX_DISMISSED_STORAGE: 100, // Keep last 100 dismissals
  MAX_STORAGE_SIZE_BYTES: 10000, // 10KB safety limit
  
  // Fallback values
  DEFAULT_LINK_TEXT: 'Learn more',
} as const;

